export default __webpack_public_path__ + "static/media/CocoaBean2Chocolate_06.e72a9e6d.png";